import React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000"
    height="24"
    width="24"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    style={{ verticalAlign: 'bottom' }}
  >
    <path d="M10 6L8.6 7.4l4.58 4.6-4.58 4.6L10 18l6-6-6-6z" fill="#0066cc" />
  </svg>
);
